export default {
  GET_TOTAL_PRICE: 'GET_TOTAL_PRICE',
  GET_TOTAL_PRICE_FORMATTED: 'GET_TOTAL_PRICE_FORMATTED',
  GET_ITEM_PRICE: 'GET_ITEM_PRICE',
  GET_ITEM_PRICE_FORMATTED: 'GET_ITEM_PRICE_FORMATTED',
  GET_TOTAL_PACKAGING_PRICE: 'GET_TOTAL_PACKAGING_PRICE',
  GET_TOTAL_PACKAGING_PRICE_FORMATTED: 'GET_TOTAL_PACKAGING_PRICE_FORMATTED',
  GET_LINES: 'GET_LINES',
  GET_CART_GROUPS: 'GET_CART_GROUPS',
  GET_OFFER_MEAL_CART_LINE: 'GET_OFFER_MEAL_CART_LINE',
  GET_LUNCH_MEAL_CART_LINE: 'GET_LUNCH_MEAL_CART_LINE',
  GET_ORDER_DELIVERY_TYPE: 'GET_ORDER_DELIVERY_TYPE',
  GET_ORDER_PAYMENT_TYPES: 'GET_ORDER_PAYMENT_TYPES',
  GET_ORDER_PAYMENT_TYPE: 'GET_ORDER_PAYMENT_TYPE',
  GET_UPDATE_CART_URL: 'GET_UPDATE_CART_URL',
  GET_FIRSTNAME: 'GET_FIRSTNAME',
  GET_LASTNAME: 'GET_LASTNAME',
  GET_PHONE: 'GET_PHONE',
  GET_EMAIL: 'GET_EMAIL',
  GET_ADDRESS: 'GET_ADDRESS',
  GET_ERRORS: 'GET_ERRORS',
  GET_IS_VALID: 'GET_IS_VALID',
  GET_NOTE: 'GET_NOTE',
  GET_TOTAL_AMOUNT: 'GET_TOTAL_AMOUNT',
}
